import { apiFetch, parseJsonSafe } from './client';

export async function adminGetAuditEvents(params = {}) {
  const search = new URLSearchParams();
  if (params.action) {
    search.set('action', String(params.action));
  }
  if (params.actor_user_id !== undefined && params.actor_user_id !== null && params.actor_user_id !== '') {
    search.set('actor_user_id', String(params.actor_user_id));
  }
  if (params.target_user_id !== undefined && params.target_user_id !== null && params.target_user_id !== '') {
    search.set('target_user_id', String(params.target_user_id));
  }
  if (params.limit !== undefined && params.limit !== null && params.limit !== '') {
    search.set('limit', String(params.limit));
  }

  const suffix = search.toString();
  const response = await apiFetch(`/users/audit${suffix ? `?${suffix}` : ''}`);
  const data = await parseJsonSafe(response);
  if (!response.ok) {
    const message =
      (typeof data?.detail === 'string' && data.detail) ||
      (typeof data?.message === 'string' && data.message) ||
      'Failed to load audit events.';
    throw new Error(message);
  }
  return Array.isArray(data) ? data : [];
}
